// extracted by mini-css-extract-plugin
module.exports = {"ourValuesHeading":"OurValues_ourValuesHeading__WncRp","valuesRow":"OurValues_valuesRow__qMAuw","valuesCard":"OurValues_valuesCard__JGNi1","textBox":"OurValues_textBox__9vXfn"};